define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/state/rootStore"
], function(declare,Widget,{ routerStore }) {

return declare(Widget,
	{
		_getFieldSelectRootURL: function(field) {
			// summary: Material is root URL for color field
			return (field.m_label == "Color") ?	routerStore.getBreadcrumbNodeURL("Material") : this.inherited(arguments);
		}
	}
);
});